import type { RouteRecordRaw } from 'vue-router'
import { LEADS_WAKEUP_FEATURE_ENABLED } from '@/constants/leadsWakeup'

const leadRoutes: RouteRecordRaw[] = LEADS_WAKEUP_FEATURE_ENABLED
  ? [
      {
        path: 'leads',
        name: 'Leads',
        component: () => import('@/views/Leads.vue'),
        meta: { title: 'AI客户唤醒' },
      },
    ]
  : [
      {
        path: 'leads',
        redirect: '/statistics',
        meta: { title: '数据概览' },
      },
    ]

export default leadRoutes
